// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import initialState from './grid';
import { appReducer } from 'store/behaviors/loader';
import capabilities from './capabilities';

const slice = createSlice({
    name: 'partnershipType',
    initialState,
    reducers: {
        ...appReducer(capabilities)
    }
});

export default slice.reducer;

export const crmPartnershipTypeActions = slice.actions;
